import React, { useState } from 'react'
import  useIsMobile  from '../../hooks/useIsMobile'
import { Download, SadFace, ChevronRight } from '../../assets/icons'
import to from 'await-catch'
import { downloadExamResult } from '../../api'
import {
	OrdersContainer,
	CardContainer,
	CardContent,
	CardHeaderRow,
	DownloadButton,
	OrdersWrapper
} from './styled'
import { LinkText, Text1, Text2 } from '../../styled/generics'
import theme from '../../styled/theme'
import { resetLabsFilters } from '../../actions'
import { connect } from 'react-redux'
import EmptyState from '../emptyState'
import { Bold } from '../../pages/private/EmergencyRoom/styled'
import ModalOrderDetail from '../ModalOrderDetail'

const isDownloadKey = key => key === 'download' || key === 'informe' || key === 'descargas'

const ResultCard = ({
	result,
	fields,
	isCarousel = false,
	onDownload,
	renderDownloads,
	renderField,
	allTitlesBold,
	showLabels = true
}) => {
	const [showOrderModal, setShowOrderModal] = useState(false)
const isMobile = useIsMobile()
	const handleDownload = async e => {
		e.preventDefault()
		const request = { actId: result.actId }
		const [err, { data } = {}] = await to(downloadExamResult(request))
		if (!err && data) {
			const link = document.createElement('a')
			link.href = data
			link.target = '_blank'
			link.click()
		}
	}

	const renderFieldValue = field => {
		if (field.renderMobile) return field.renderMobile(result)
		if (field.render) return field.render(result)
		if (renderField) return renderField(field, result)
		const label = showLabels && field.label ? `${field.label}: ` : ''
		if (field.bold) {
			return (
				<Text2 size={field.size || '16px'} color={theme.colors.text.primaryText}>
					<Bold>
						{label}
						{result[field.key]}
					</Bold>
				</Text2>
			)
		}
		return (
			<Text2 size={field.size || '16px'} color={theme.colors.text.secondaryText}>
				{allTitlesBold ? (
					<>
						<Bold>{label}</Bold>
						{result[field.key]}
					</>
				) : (
					`${label}${result[field.key]}`
				)}
			</Text2>
		)
	}

	const visibleFields = (fields || []).filter(
		field => !isDownloadKey(field.key) && field.key !== 'info' && field.showInMobile !== false
	)
	const headerLeftFields = visibleFields.filter(
		field => field.mobileHeader === true || field.mobileHeader === 'left'
	)
	const headerRightFields = visibleFields.filter(field => field.mobileHeader === 'right')
	const bodyFields = visibleFields.filter(field => !field.mobileHeader)
	const hasHeader = headerLeftFields.length > 0 || headerRightFields.length > 0

	return (
		<CardContainer isCarousel={isCarousel}>
			<CardContent>
				{hasHeader && (
					<CardHeaderRow>
						<div>
							{headerLeftFields.map(field => (
								<React.Fragment key={field.key}>{renderFieldValue(field)}</React.Fragment>
							))}
						</div>
						<div>
							{headerRightFields.map(field => (
								<React.Fragment key={field.key}>{renderFieldValue(field)}</React.Fragment>
							))}
						</div>
					</CardHeaderRow>
				)}
				{bodyFields.map(field => (
					<React.Fragment key={field.key}>{renderFieldValue(field)}</React.Fragment>
				))}
				{renderDownloads && renderDownloads(result)}
			</CardContent>
			{fields && fields.some(f => f.key === 'download' || f.key === 'informe') && !renderDownloads && (
				<DownloadButton href="#" onClick={handleDownload}>
					<Download />
					<LinkText size={'16px'}>Descargar</LinkText>
				</DownloadButton>
			)}
			{fields && fields.some(f => f.key === 'info') && (
				<DownloadButton as="div" onClick={() => setShowOrderModal(true)}>
					<LinkText as="span" size={'16px'}>Ver más</LinkText>
					<ChevronRight size={isMobile ? 11 : 16} color={theme.colors.brand.blueOmint} />
				</DownloadButton>
			)}
			{showOrderModal && (
				<ModalOrderDetail order={result} onClose={() => setShowOrderModal(false)} />
			)}
		</CardContainer>
	)
}

const ResultsList = ({
	results = [],
	fields,
	isCarousel,
	onDownload,
	renderDownloads,
	renderField,
	isSearch,
	allTitlesBold = false,
	showLabels = true,
	style
}) => {
	const resultsList = Array.isArray(results)
		? results
		: results && Array.isArray(results.items)
		? results.items
		: []

	return (
		<OrdersWrapper style={style}>
			<OrdersContainer theme={theme} isCarousel={isCarousel}>
				{resultsList.map(result => (
					<ResultCard
						isCarousel={isCarousel}
						key={result.id}
						result={result}
						fields={fields}
						onDownload={onDownload}
						renderDownloads={renderDownloads}
						renderField={renderField}
						allTitlesBold={allTitlesBold}
						showLabels={showLabels}
					/>
				))}

				{resultsList?.length === 0 && (
					<EmptyState actionButton={resetLabsFilters} isSearch={isSearch} />
				)}
			</OrdersContainer>
		</OrdersWrapper>
	)
}

const mapDispatchToProps = {
	resetLabsFilters
}

export default connect(null, mapDispatchToProps)(React.memo(ResultsList))
